import React, { useContext, useState } from "react";
import LangContext from "./langContext";
import { Rating } from "Components/Base/Inputs/Rating";
import BaseGrid from "Components/Fragment/BaseGrid";
import { Button } from "Components/Base/Inputs/Button";
import { Box } from "Components/Base/Layout/Box";
import { InputLabel } from "Components/Base/Inputs/InputLabel";
import { TextFieldMultiline } from "Components/Base/Inputs/TextFieldMultiline";

const RatingForm = (props) => {
  const { tempRating, tempComment, saveRating, closeRatingForm } = props;
  const languageContext = useContext(LangContext);
  const [rating, setRating] = useState(tempRating || 0);
  const [comment, setComment] = useState(tempComment || "");
  const [saved, setSaved] = useState(false);

  const changeRating = (value) => {
    setRating(value);
  };

  const save = () => {
    if (rating === 0) {
      setSaved(true);
      return;
    }
    saveRating(rating, comment);
  };

  const showErrorMessage = !rating && saved;

  return (
    <BaseGrid>
      {showErrorMessage && (
        <div className="error" role="alert">
          {languageContext("pleaseenterratingbeforesaving")}
        </div>
      )}
      <Rating
        value={rating}
        size="large"
        onChange={(_, value) => changeRating(value)}
      />
      <Box mb={-1} width="fit-content">
        <InputLabel htmlFor="txtComment">
          {`${languageContext("comment")}:`}
        </InputLabel>
      </Box>
      <TextFieldMultiline
        id="txtComment"
        onChange={(e) => setComment(e.target.value)}
        value={comment}
        minRows={3}
        fullWidth
      />
      <BaseGrid childWidth="auto" justifyContent="end">
        {closeRatingForm && (
          <Button
            onClick={closeRatingForm}
            color="secondary"
            variant="outlined"
            label={languageContext("close")}
          />
        )}
        <Button onClick={save} label={languageContext("save")} />
      </BaseGrid>
    </BaseGrid>
  );
};

export default RatingForm;
